
import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { me } from '../AuthenticatedPage/authenticationSlice';
import { fetchOnlineServices, favoriteOnlineServices } from './service';
import { SLICE_NAME } from './constants';

function* requestOnlineServices(action) {
    const { userId, parentUserId } = yield select(me);
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchOnlineServices, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({
            type: `${SLICE_NAME}/list`,
            payload: response,
        });
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: { message: response.error.description, extraInfo: response.error.extraInfo, details: response.error.details } });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* requestUpdateFavoriteOnlineServices(action) {
    const { userId, parentUserId } = yield select(me);
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(favoriteOnlineServices, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({
            type: `${SLICE_NAME}/list`,
            payload: response,
        });
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: { message: response.error.description, extraInfo: response.error.extraInfo, details: response.error.details } });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* getOnlineServices() {
    yield takeLatest(`${SLICE_NAME}/requestOnlineServices`, requestOnlineServices);
}

function* updateFavoriteOnlineServices() {
    yield takeLatest(`${SLICE_NAME}/requestUpdateFavoriteOnlineServices`, requestUpdateFavoriteOnlineServices);
}

export { getOnlineServices, updateFavoriteOnlineServices };